// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Co-z","breadcrumbForward":"Do-z","breadcrumbBack":"Eo-z","selected":"Fo-z"};